import React from "react";
import { NavLink } from "react-router-dom";
import "./header.css";
import Logo from './image.png';

const Header = () => {
    return (
        <header className="header">
            <div className="header-container">
                <div className="logo-section">
                    <img src={Logo} alt="AM Services Logo" />
                </div>

                <nav className="nav-links">
                    <NavLink
                        to="/suivi"
                        className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}
                    >
                        🔧 <span>Suivi Réparations</span>
                    </NavLink>

                    {/* Nouveau lien RMA */}
                    <NavLink
                        to="/rma"
                        className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}
                    >
                        🔄 <span>Gestion RMA</span>
                    </NavLink>

                    <NavLink
                        to="/gestionmateriel"
                        className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}
                    >
                        📦 <span>Prêts Matériel</span>
                    </NavLink>
                </nav>

                <div className="header-actions">
                    <div className="user-badge">Admin</div>
                </div>
            </div>
        </header>
    );
};

export default Header;
